import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { TableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AudienceTypeEnum } from '../shared/audience-type.enum';
import { AudienceIndividual } from '../shared/models/audience-individual.model';

@Component({
  selector: 'app-audience-list',
  templateUrl: './audience-list.component.html',
  styleUrls: ['./audience-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AudienceListComponent implements OnInit, OnDestroy {
  @Input() segmentsLength: number;
  @Input() hasFilters: boolean;
  @Input() statisticsBS: BehaviorSubject<{
    optins: { retrieved: number; total: number };
    optouts: { retrieved: number; total: number };
  }>;
  @Input() users: BehaviorSubject<{
    usersOptinList: AudienceIndividual[];
    usersOptoutList: AudienceIndividual[];
  }>;

  @Output() fetchUsers: EventEmitter<any> = new EventEmitter();

  displayedColumnsForOptins = [
    'id',
    'account_name',
    'external_id',
    'name',
    'real_name',
    'is_vip',
    'user_optin_date',
    'gdpr_optout_date',
    'is_active_for_period',
    'last_message_language',
  ];
  displayedColumnsForOptouts = [
    'id',
    'account_name',
    'external_id',
    'name',
    'real_name',
    'is_vip',
    'user_optin_date',
    'optout_date',
    'optout_reason',
    'last_message_language',
  ];
  displayedColumns = [];

  dataSource = new TableVirtualScrollDataSource([]);
  lastId = null;
  maxHeight = 960; // 20 x 48 [items x row height in px]

  /**
   * Allows to have a full responsive table by taking the available height. The overflow of the table will be visible by using a scroll.
   */
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.maxHeight = Math.min(document.getElementById('right-side-content').clientHeight - 150, 960);
  }

  selectedTabIndex = AudienceTypeEnum.OPTIN;

  private subscriptions = new Subscription();

  private companyId = this.alcmeonContextService.companyId;

  constructor(
    private alcmeonContextService: AlcmeonContextService,
    @Inject('$state') private $state: any,
    @Inject('$stateParams') private $stateParams: any
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.users.subscribe(values => {
        this.usersFetched(values);
      })
    );
  }

  redirectToNewSegment() {
    this.$state.go('auth.alcmeon.fuse.segments', {
      companyId: this.companyId,
      redirectedFromAudience: true,
    });
  }

  usersFetched(values: { usersOptinList: AudienceIndividual[]; usersOptoutList: AudienceIndividual[] }) {
    let dataSource: AudienceIndividual[];
    if (this.selectedTabIndex === AudienceTypeEnum.OPTOUT) {
      dataSource = values.usersOptoutList;
      this.displayedColumns = this.displayedColumnsForOptouts;
    } else {
      dataSource = values.usersOptinList;
      this.displayedColumns = this.displayedColumnsForOptins;
    }
    this.dataSource = new TableVirtualScrollDataSource(dataSource);
    this.onResize();
  }

  selectedTabChanged($event) {
    this.selectedTabIndex = $event;
    this.usersFetched(this.users.value);
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }
}
